import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Button, Grid } from "@material-ui/core"
import userFunnelAnalysis from "../../../assets/images/funnel/user_funnel_analysis.png"
import userFunnelAnalysisEn from "../../../assets/images/funnel/user_funnel_analysis_en.png"
import userFunnelAnalysisMobileEn from "../../../assets/images/funnel/user_funnel_analysis_mobile_en.png"
import gradient from "../../../assets/images/funnel/gradient.png"
import useLoginPopup from "../../../hooks/useLoginPopup"
import { useTrack } from "@hackler/react-sdk"
import usePlatform from "../../../hooks/usePlatform"
import { GAEvent } from "../../../modules/GoogleAnalytics"
import { Locale } from "../../../locale"
import { FormattedMessage } from "react-intl"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: `url(${gradient}) center bottom no-repeat`,
      backgroundColor: "#051A52",
      backgroundSize: "auto 80%",
      padding: "48px 0 0",
      [theme.breakpoints.up("md")]: {
        padding: "80px 0 0",
      },
    },
    title: {
      fontSize: "24px",
      lineHeight: "140%",
      color: "#FFFFFF",
      letterSpacing: -1,
      [theme.breakpoints.up("md")]: {
        fontSize: "48px",
      },
    },
    buttonWrapper: {
      marginBottom: 40,
      [theme.breakpoints.up("md")]: {
        marginBottom: 74,
      },
    },
    button: {
      borderRadius: 8,
      textTransform: "none",
      color: theme.palette.common.white,
      padding: "8px 16px",
      fontSize: 14,
      [theme.breakpoints.up("md")]: {
        padding: "12px 20px",
        fontSize: 20,
      },
    },
    imageWrapper: {
      padding: "0 20px",
      marginBottom: -80,
      "& img": {
        width: "100%",
        borderRadius: 4,
        filter: "drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.15))",
      },
      [theme.breakpoints.up("md")]: {
        marginBottom: -137,
        "& img": {
          width: "auto",
          maxWidth: 994,
          borderRadius: 16,
          filter: "drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.15))",
        },
      },
    },
  })
)

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function MainVisual() {
  const loginPopup = useLoginPopup()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  const track = useTrack()
  const classes = useStyles()

  // const { ref } = useScrollImpressionLog({
  //   message: "1. 사용자 퍼널 분석을 통해 효율적이고 빠른 서비스 성장",
  //   eventKey: `homepage_funnel_section_1_impression`,
  // })

  return (
    <div className={classes.root}>
      <Grid container style={{ textAlign: "center" }}>
        <Grid item xs={12} style={{ marginBottom: "40px" }}>
          {lang === "ko" ? (
            <strong className={classes.title}>
              사용자 퍼널 분석을 통해
              <br />
              효율적이고 빠른 서비스 성장을
              {isMobile ? <br /> : " "}경험해보세요
            </strong>
          ) : (
            <strong className={classes.title}>
              Boost your conversions {isMobile ? <br /> : " "}and growth through
              <br />
              funnel analysis
            </strong>
          )}
        </Grid>
        <Grid className={classes.buttonWrapper} item xs={12}>
          <Button
            onClick={() => {
              track({ key: "homepage_all_funnel_start_click" })
              track({ key: "homepage_funnel_section_1_funnel_start_click" })
              GAEvent({
                category: "funnel-1",
                action: "click",
                label: "start funnel",
              })
              loginPopup(`${dashboardUrl}/funnels`)
            }}
            color={"primary"}
            variant={"contained"}
            className={classes.button}>
            <strong>
              <FormattedMessage id={"btn_funnel_hero_section"} />
            </strong>
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.imageWrapper}>
          {lang === "ko" ? (
            <img src={userFunnelAnalysis} alt={"user funnel analysis"} />
          ) : (
            <img src={isMobile ? userFunnelAnalysisMobileEn : userFunnelAnalysisEn} alt={"user funnel analysis"} />
          )}
        </Grid>
      </Grid>
    </div>
  )
}
